import React, { useState, useEffect } from 'react';
import { Alert, Button } from 'react-bootstrap';
import { findDuplicateBankAccounts } from '../../services/BankAccountService';

const DuplicateWarning = ({ bankAccountName, bankAccountId }) => {
  const [duplicateInfo, setDuplicateInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const checkForDuplicates = async () => {
      try {
        setLoading(true);
        const duplicatesData = await findDuplicateBankAccounts();
        
        if (duplicatesData.duplicate_count > 0 && 
            duplicatesData.duplicates[bankAccountName] && 
            duplicatesData.duplicates[bankAccountName].length > 1) {
          setDuplicateInfo(duplicatesData.duplicates[bankAccountName]);
        } else {
          setDuplicateInfo(null);
        }
      } catch (err) {
        console.error('Error checking for duplicate accounts:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    if (bankAccountName) {
      checkForDuplicates();
    }
  }, [bankAccountName]);

  if (loading) return null;
  if (error) return null;
  if (!duplicateInfo || duplicateInfo.length <= 1) return null;

  return (
    <Alert variant="warning">
      <p><strong>Duplicate Bank Account Detected!</strong></p>
      <p>There are {duplicateInfo.length} bank accounts named "{bankAccountName}" in the database:</p>
      <ul>
        {duplicateInfo.map(acc => {
          const reqCount = acc.requirements_count;
          const reqSummary = reqCount > 0 
            ? `Has ${reqCount} requirement${reqCount > 1 ? 's' : ''}`
            : 'Has no requirements';
            
          return (
            <li key={acc.id}>
              <strong>ID {acc.id}</strong> - {reqSummary}
              {acc.id === bankAccountId && ' (current account)'}
            </li>
          );
        })}
      </ul>
      <p>This may cause confusion with requirements and transfers.</p>
      <div className="d-flex gap-2">
        <Button 
          variant="outline-danger" 
          size="sm"
          onClick={() => {
            alert('Please contact support to resolve this account issue.');
          }}
        >
          How to Fix This
        </Button>
      </div>
    </Alert>
  );
};

export default DuplicateWarning; 